'use client';

import React, { useState, useEffect } from 'react';

export interface SignadotBannerProps {
    /** Whether the banner should be visible initially */
    isVisible?: boolean;
    /** Custom class name for styling */
    className?: string;
    /** Sandbox/environment information to display */
    sandboxInfo?: string;
}

export default function SignadotBanner({
    isVisible = false,
    className = '',
    sandboxInfo = 'Development Preview Environment',
}: SignadotBannerProps) {
    const [isDismissed, setIsDismissed] = useState(false);

    const handleDismiss = () => {
        setIsDismissed(true);
    };

    // Don't show if dismissed or not visible
    if (isDismissed || !isVisible) {
        return null;
    }

    return (
        <div
            className={`
        fixed top-0 left-0 right-0 z-50 
        bg-gradient-to-r from-blue-500 to-purple-600 
        text-white text-sm py-2 px-4 
        flex items-center justify-between
        shadow-md
        ${className}
      `}
            role="banner"
            aria-label="Development environment notification"
        >
            <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
                <span className="font-medium">🚀 {sandboxInfo} - Signadot Active</span>
            </div>

            <button
                onClick={handleDismiss}
                className="
          p-1 hover:bg-white/20 rounded-full transition-colors
          focus:outline-none focus:ring-2 focus:ring-white/50
        "
                aria-label="Dismiss banner"
                title="Dismiss"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>
    );
}
